import { Layout, Menu } from 'antd'
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, Route, Switch, useLocation  } from 'react-router-dom'
import logo from '@/assets/logo.png'
import * as Loadable from 'react-loadable'
import loading from '../../router/loading'
import UserPanel from '../../components/UserPanel/UserPanel'
import './style.less'

const { SubMenu } = Menu
const { Header, Sider, Content } = Layout
const RouterList: any[] = [
  {
    component: () => import('../../pages/Home/Home'),
    path: '/sider/home',
    name: 'home'
  },
  {
    component: () => import('../../pages/AccountData/AccountData'),
    path: '/sider/account-data',
    name: 'accountData'
  },
  {
    component: () => import('../../pages/AgentMonitor/AgentMonitor'),
    path: '/sider/agent-monitor',
    name: 'agentMonitor'
  },
  {
    component: () => import('../../pages/Bind/Bind'),
    path: '/sider/bind',
    name: 'bind'
  },
  {
    component: () => import('../../pages/AccountInfo/AccountInfo'),
    path: '/sider/account-info',
    name: 'accountInfo'
  },
  {
    component: () => import('../../components/AuthDetail/AuthDetail'),
    path: '/sider/auth-center',
    name: 'authCenter'
  },
  {
    component: () => import('../../pages/Message/Message'),
    path: '/sider/message',
    name: 'message'
  },
  {
    component: () => import('../../pages/Verify/Verify'),
    path: '/sider/verify',
    name: 'verifyCenter',
    parent: 'verifyCenter'
  },
  {
    component: () => import('../../pages/WhiteList/WhiteList'),
    path: '/sider/white-list-manage',
    name: 'whiteListManage',
    parent: 'verifyCenter'
  },
  {
    component: () => import('../../pages/ExcellentVideo/ExcellentVideo'),
    path: '/sider/excellent-video',
    name: 'excellentVideo',
    parent: 'materialShare'
  },
  {
    component: () => import('../../pages/AuthManage/AuthManage'),
    path: '/sider/auth-manage',
    name: 'authManage'
  }
]

const NoPerm = () => import('../../components/NoPerm/NoPerm')

const menus = [
  {
    key: 'home',
    name: 'home',
    class: 'BM_icicon_homepage_line',
    label: '首页'
  },
  {
    key: 'account-data',
    name: 'accountData',
    class: 'BM_icicon_data_Unselected',
    label: '账户数据'
  },
  {
    key: 'agent-monitor',
    name: 'agentMonitor',
    class: 'BM_icicon_Monitor_Unselected',
    label: '代理监控'
  },
  {
    key: 'bind',
    name: 'bind',
    class: 'BM_icicon_binding_line',
    label: '账户绑定'
  },
  // {
  //   key: 'share',
  //   name: 'materialShare',
  //   class: 'BM_icsucaiicon1',
  //   label: '素材共享',
  //   children: [
  //     {
  //       key: 'excellent-video',
  //       name: 'excellentVideo',
  //       label: '优秀视频',
  //       parent: 'materialShare'
  //     },
  //     {
  //       key: 'video-depo',
  //       name: 'videoDepo',
  //       label: '视频库',
  //       parent: 'materialShare'
  //     }
  //   ]
  // },
  {
    key: 'account-info',
    name: 'accountInfo',
    class: 'BM_icicon_information_line',
    label: '用户信息'
  },
  {
    key: 'auth-center',
    name: 'authCenter',
    class: 'BM_icicon_Authentication_line',
    label: '认证中心'
  },
  {
    key: 'verify',
    name: 'verifyCenter',
    class: 'BM_icicon_audit_center',
    label: '审核中心',
    children: [
      {
        key: 'verify',
        name: 'verifyCenter',
        label: '主体审核',
        parent: 'verifyCenter'
      },
      {
        key: 'white-list-manage',
        name: 'whiteListManage',
        label: '白名单管理',
        parent: 'verifyCenter'
      }
    ]
  },
  {
    key: 'auth-manage',
    name: 'authManage',
    class: 'BM_icbianzu15',
    label: '授权管理'
  },
]

function App(props: any) {
  const history = useHistory()
  const location = useLocation()
  let pathname = location.pathname
  const [selectedKeys, setKeys] = useState(['home'])
  useEffect(() => {
    // 设定菜单栏默认选中
    let lastIndex = pathname.lastIndexOf('/')
    let path = pathname.slice(lastIndex + 1)
    setKeys([path])
  }, [pathname])
  // 获取用户权限，并跳转到有权限的第一个菜单页面
  const perms = useSelector((state: any) => state.user.perm)
  useEffect(() => {
    if (perms) {
      let items = RouterList.filter(router => perms.includes(router.name) || perms.includes(router.parent)).map(item => item.path)
      if (!items.includes(location.pathname)) {
        history.push(items[0])
      }
    }
  }, [perms])
  const handleMenuClick = (item: any) => {
    history.push(`/sider/${item.key}`)
  }
  return (
    <Layout className="bm-layout">
      <Sider className="bm-sider" width="188" theme="light">
        <div className="bm-logo">
          <img src={logo} />
          <span>AICLK账户管家</span>
        </div>
        <Menu className="bm-menu" theme="light" mode="inline" selectedKeys={selectedKeys} onClick={handleMenuClick} forceSubMenuRender={true}>
          {perms && menus.filter(menu => perms.includes(menu.name)).map(item => {
            return item.children ? (
              <SubMenu key={item.key} title={
                <span>
                  <i className={`iconfont ${item.class}`} />
                  <span>{item.label}</span>
                </span>
              }>
                {item.children.map(sub => {
                  return ( 
                    <Menu.Item key={sub.key}>
                      <span>{sub.label}</span>
                    </Menu.Item> 
                  )
                })}
              </SubMenu>
            ) : (
              <Menu.Item key={item.key}>
                <i className={`iconfont ${item.class}`} />
                <span>{item.label}</span>
              </Menu.Item>
            )
          })}
        </Menu>
      </Sider>
      <Layout>
        <Header className="bm-header" style={{ background: '#fff', padding: 0, position: 'relative' }}>
          <UserPanel />
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            background: '#fff',
            minHeight: 'auto'
          }}
        >
          <Switch>
            {RouterList.map(item => (
              <Route
                key={item.path}
                path={item.path}
                component={
                  perms && (perms.includes(item.name) || perms.includes(item.parent)) ?
                  Loadable({
                    loader: item.component,
                    loading
                  }) : 
                  Loadable({
                    loader: NoPerm,
                    loading
                  })
                }
              />
            ))}
          </Switch>
        </Content>
      </Layout>
    </Layout>
  );
}

export default App


// WEBPACK FOOTER //
// ./src/containers/App/App.tsx